/**
 * Requires the charts.js library
 */
Chart.defaults.plugins.tooltip.titleFont = () => (
	{ size: 20, lineHeight: 1, weight: 400, family: "Roboto" }
);
Chart.defaults.plugins.tooltip.bodyFont = () => (
	{ size: 20, lineHeight: 1, weight: 400, family: "Roboto" }
);
Chart.defaults.plugins.tooltip.titleColor 		 = '#fff';
Chart.defaults.plugins.tooltip.bodyColor 			 = '#219de7';
Chart.defaults.plugins.tooltip.backgroundColor = 'rgba( 0, 65, 113, .8 )';

Chart.defaults.font = { family: "Roboto", size: 20 };

Chart.defaults.plugins.colors.enabled = false;
